// import { useState } from 'react'

const Audio = ({
	containerClassName,
	className = 'h-12 w-full',
	audioURL,
}: {
	containerClassName?: string
	className?: string
	audioURL?: string
}) => {
	return (
		<div className={containerClassName}>
			<audio className={className} controls src={audioURL} preload="metadata" />
		</div>
	)
}

export default Audio
